import Badge from 'react-bootstrap/Badge'
import OverlayTrigger from 'react-bootstrap/OverlayTrigger'
import Tooltip from 'react-bootstrap/Tooltip'

import Icon from '@/components/Icon/Icon'
import LinkHelper from '@/components/Panels/LinkHelper/LinkHelper'
import { TagLinkType } from '@/types/page'
import useDirectories from '@/utils/useDirectories'

import styles from './NavigationPanel.module.scss'
import TagsTypeahead from './TagsTypeahead/TagsTypeahead'

type Props = {
  bracket?: string
  budget?: string
  sanitized_wo: string
  tag?: string
  tags: TagLinkType[]
}

const NavigationPanelTags = ({ bracket, budget, sanitized_wo, tag, tags }: Props) => {
  const { dir, subsubpage } = useDirectories()

  if (tags.length === 0) return null

  /* Tag rows
    Build a list of tags to display based on the following rules:
    - If there are [numTagRows] or fewer tags, display all of them
    - If there are more than [numTagRows] tags, display the first [numTagRows - 1] plus the dropdown
    - If the selected theme is not in the first [numTagRows], display it as the 6th */
  const numTagRows = 5
  const selectedTagIndex = tags?.findIndex((tag) => tag['slug'] === subsubpage)
  const displayedTags =
    tags.length < numTagRows
      ? tags
      : selectedTagIndex < (tags.length > numTagRows ? numTagRows - 1 : numTagRows)
        ? tags.slice(0, numTagRows - 1)
        : [...tags.slice(0, numTagRows - 2), tags[selectedTagIndex]]
  const tagRows = tags.length === numTagRows ? [...displayedTags, tags[numTagRows - 1]] : displayedTags

  if (tagRows) {
    return (
      <div>
        <div className={styles.navigationTitle}>
          Tags
          <OverlayTrigger
            overlay={
              <Tooltip>
                <div>
                  <b>Tags</b> are directly pulled from
                </div>
                <div>Archidekt tags and Moxfield hubs,</div>
                <div>& supplemented by EDHREC-detected themes.</div>
              </Tooltip>
            }
            placement='top'
          >
            <span className={styles.tooltipIcon}>
              <Icon icon='circleQuestion' size='lg' />
            </span>
          </OverlayTrigger>
        </div>
        <div className={styles.tags}>
          {tagRows.map((tagRow) => {
            const count = budget ? Math.floor(tagRow.count / 10) : tagRow.count
            if (count === 0) return null

            const primary = tagRow['slug'] === tag
            const href = `/${dir}/${sanitized_wo}${bracket ? `/${bracket}` : ''}/${tagRow['slug']}${budget ? `/${budget}` : ''}`
            return (
              <LinkHelper
                href={
                  primary ? `/${dir}/${sanitized_wo}${bracket ? `/${bracket}` : ''}${budget ? `/${budget}` : ''}` : href
                }
                key={tagRow.value}
                primary={primary}
                scroll={false}
              >
                <span className={styles.label}>{tagRow.value}</span>
                <Badge bg='light' className='text-dark'>
                  {count >= 1000 ? `${Math.floor(count / 1000)}K` : count}
                </Badge>
              </LinkHelper>
            )
          })}
        </div>
        {tags.length > tagRows.length && (
          <TagsTypeahead bracket={bracket} budget={budget} sanitized_wo={sanitized_wo} tags={tags} />
        )}
      </div>
    )
  }
}

export default NavigationPanelTags
